__turbopack_context__.v({
  "btw": "UDEoiW_btw",
  "contactBox": "UDEoiW_contactBox",
  "footer": "UDEoiW_footer",
  "location": "UDEoiW_location",
  "mail": "UDEoiW_mail",
  "mailIcon": "UDEoiW_mailIcon",
  "mailText": "UDEoiW_mailText",
  "mapPin": "UDEoiW_mapPin",
  "mapPinIcon": "UDEoiW_mapPinIcon",
  "socials": "UDEoiW_socials",
});
